import React from "react";
import CommercialPlaceHolderIcon from "../../Icons/CommercialPlaceHolderIcon";
import AgriculturePlaceHolderIcon from "../../Icons/AgriculturePlaceHolderIcon";
import ResidencialPlaceHolderIcon from "../../Icons/ResidencialPlaceHolderIcon";
import { IconTitleDescriptionActionCard } from "@reusejs/react";

const PlaceHolderContent = () => {
  const AllContent = [
    {
      icon: <CommercialPlaceHolderIcon />,
      iconPosition: "left",
      title: "",
      description:
        "At AuctionBazaar, we offer a wide variety of properties for auction, including commercial, residential, agricultural, industrial, and movable assets. Our platform allows buyers to connect quickly and transact securely and efficiently.",
    },
    {
      icon: <AgriculturePlaceHolderIcon />,
      iconPosition: "left",
      title: "",
      description:
        "Whether you are a business owner looking for a new office or warehouse, an investor searching for a profitable property, or a family searching for a new home, AuctionBazaar has various options to suit your needs.",
    },
    {
      icon: <ResidencialPlaceHolderIcon />,
      iconPosition: "left",
      title: "",
      description:
        "Our real-time updates and user-friendly interface ensure you take advantage of every great opportunity and get your dream property.",
    },
    {
      icon: <CommercialPlaceHolderIcon />,
      iconPosition: "left",
      title: "",
      description:
        "We're passionate about providing our users with the best possible experience, which is why we've created a platform that is both transparent and fair.",
    },
    {
      icon: <AgriculturePlaceHolderIcon />,
      iconPosition: "left",
      title: "",
      description:
        "With our commitment to integrity, you can trust that online property auctions on AuctionBazaar are conducted with the highest standards and transparency.",
    },
    {
      icon: <ResidencialPlaceHolderIcon />,
      iconPosition: "left",
      title: "",
      description:
        "So why wait? Start browsing our selection of bank properties for sale today, and find the perfect investment opportunity for you!",
    },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 bg-white lg:my-20 gap-y-10 gap-x-6 max-w-7xl m-auto px-4 lg:px-8">
      {AllContent.map((item: any, index: any) => {
        return (
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            description={item.description}
            iconPosition="left"
            itemTitleDescriptionCardBaseClasses={{
              wrapper: "bg-gray-50 lg:bg-white p-4 lg:p-0 mt-4 lg:mt-0",
              iconWrapper:
                "flex h-12 w-12 items-center justify-center rounded-md text-white",
              titleWrapper: "mt-5 text-left",
              titleStyles:
                "text-md leading-6 font-bold md:text-lg text-gray-900",
              descriptionWrapper: "text-left mt-2",
              descriptionStyles: "text-sm md:text-base text-gray-500",
              actionWrapper: "mt-2 text-left",
            }}
          />
        );
      })}
    </div>
  );
};

export default PlaceHolderContent;
